import ongoing_compliance_checklist_token_countdown_mixin from "@/utils/mixins/compliance_mixins/ongoing_compliance_checklist_token_countdown_mixin";
import ongoing_compliance_checklist_rule_crud_mixin from "@/utils/mixins/compliance_mixins/ongoing_compliance_checklist_rule_crud_mixin";

export default {
  mixins: [
    ongoing_compliance_checklist_token_countdown_mixin,
    ongoing_compliance_checklist_rule_crud_mixin,
  ],

  mounted() {
    this.$nextTick(() => {
      this.initialize_modals();
    });
  },

  created() {
    this.initializeToken()
      .then(() => {
        this.entity_type_id = sessionStorage.getItem("entity_type_id");
        this.rule_form.entity_type = this.entity_type_id;
        this.get_compliance_rules();
      })
      .catch(error => {
        this.show_error("Failed to initialize token: " + error.message);
      });
  },

  computed: {
    table_safe_rule_list() {
      return Array.isArray(this.rules) ? this.rules : [];
    },

    calculated_frequency_days() {
      if (this.rule_form.frequency_type === "custom") {
        return this.rule_form.custom_frequency_days || 0;
      }

      const frequencyMap = {
        weekly: 7,
        biweekly: 14,
        monthly: 30,
        quarterly: 90,
        biannually: 180,
        annually: 365,
      };

      return Reflect.get(frequencyMap, this.rule_form.frequency_type) || 30;
    },
  },

  methods: {},

  beforeUnmount() {
    if (this.createRuleModal) {
      this.createRuleModal.dispose();
    }
    if (this.deleteConfirmationModal) {
      this.deleteConfirmationModal.dispose();
    }
    if (this.assignQuestionsModal) {
      this.assignQuestionsModal.dispose();
    }

    if (this.dataTable) {
      this.dataTable.destroy();
    }
  },
};

